import typeToReducer from 'type-to-reducer';
import update from 'immutability-helper';
import { Reducer } from '@reduxjs/toolkit';
import { newsInitialState, NewsInitialStateType } from '../store/initialState';
import { parseAxiosError } from '../utils/axiosResponseHelper';
import { PublistaAction } from '../infrastructure/commonTypes';

export const newsReducer: Reducer<NewsInitialStateType, PublistaAction> =
  typeToReducer<NewsInitialStateType, PublistaAction>(
    {
      CITY_NEWS_GET: {
        PENDING: (state: NewsInitialStateType) =>
          update(state, {
            fetching: { $set: true },
          }),
        REJECTED: (state: NewsInitialStateType, action: any) => {
          const payload = action?.payload;

          return update(state, {
            fetching: { $set: false },
            fetched: { $set: false },
            error: { $set: parseAxiosError(payload) },
          });
        },
        FULFILLED: (state: NewsInitialStateType, action: any) => {
          const payload = action?.payload;

          return update(state, {
            fetching: { $set: false },
            fetched: { $set: true },
            data: { $set: payload.data },
            error: { $set: null },
          });
        },
      },
    },
    newsInitialState
  );
